import * as React from "react"

import Layout from "../components/common/layout"
import PageQlikPortalBlock from "../templates/page-blocks/PageQlikPortalBlock"

const shopperAppId = "16953c74-109d-49ad-9f1c-ccd5fed1cda7"
const shopperSheetId = "e8b50bba-abd9-42db-8b96-ade96588e54e"

const shopperQlikBlock = {
  id: "insights-suite-shopper-test-qlik",
}

const ShopperTestPage = () => (
  <Layout>
    <div className="mediaInsightsPortal shopper-test-page">
      <style>
        {`
          .shopper-test-page .qlik_embed__heading,
          .shopper-test-page .qlik_embed__source {
            display: none;
          }
        `}
      </style>
      <PageQlikPortalBlock
        block={shopperQlikBlock}
        appId={shopperAppId}
        sheetId={shopperSheetId}
      />
    </div>
  </Layout>
)

export default ShopperTestPage
